"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var TradeInDetails_1 = require("./TradeInDetails");
var TradeInDetailsWrapper = function (_a) {
    var attributes = _a.attributes;
    var _b;
    if (!((_b = attributes) === null || _b === void 0 ? void 0 : _b.tradeIn)) {
        return null;
    }
    return (<TradeInDetails_1.default make={attributes.tradeInMake} model={attributes.tradeInModel} variant={attributes.tradeInVariant} year={attributes.tradeInYear} mileage={attributes.tradeInMileage} colour={attributes.tradeInColour} registrationNumber={attributes.tradeInRegistrationNumber} comment={attributes.tradeInComment}/>);
};
exports.default = TradeInDetailsWrapper;
